import React from 'react';
import _get from 'lodash/get';
import { useLocation } from 'react-router-dom';
import CustomError from './CustomError';

const Error: React.FC<{}> = () => {
	const location = useLocation();
	const statusCode = _get(location, ['state', 'statusCode'], 405);
	const errorMsg = _get(location, ['state', 'errorMsg'], 'Error Occured :(');

	return <CustomError statusCode={statusCode} errorMsg={errorMsg} />;
};

export default Error;
